import React, { useState, useContext } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { AiOutlineWarning } from "react-icons/ai";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAxiosPrivateUploadFile from "../../../hooks/useAxiosPrivateUploadFile";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import MyJustDate from "../../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API;

export default function Add({
  increment,
  counter,
  moamad,
  docOptions,
  hagsha_aharon,
}) {
  let formdataFile = new FormData();
  const [newDoc, setNewDoc] = useState({
    file_url: "",
    doc_type: "",
    moamad: moamad.id,
  });
  const readOnly =
    !(
      moamad?.extention_date &&
      MyJustDate(new Date(Date.parse(moamad?.extention_date))) >=
        MyJustDate(Date.now())
    ) &&
    (moamad.signature_date ||
      MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now()));
  /* const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());*/

  const axiosPrivate = useAxiosPrivateUploadFile();
  const [isUplading, setIsUplading] = useState(false);
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewDoc((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    e.preventDefault();
    let ext = e.target.files[0].name.split(".").pop();
    let size = e.target.files[0].size;
    if (size < 5000001) {
      formdataFile.append("file", e.target.files[0], "mdocument." + ext);
      setNewDoc((prevState) => ({
        ...prevState,
        ["file_url"]: formdataFile.get("file"),
      }));
    } else {
      alert("לא ניתן להעלות קובץ גדול מ 5MB");
    }
    setIsUplading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData = {
      moamad: moamad.id,
      doc_type: newDoc.doc_type,
      file_url: newDoc.file_url,
    };
    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      setIsUplading(true);
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/moamaddocument/",
          formData,
          {
            signal: controller.signal,
          }
        );
        setNewDoc({
          file_url: "",
          doc_type: "",
          moamad: moamad.id,
        });
        alert("המסמך נוסף בהצלחה");
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else:", err);
        }
      }
      setIsUplading(false);
    };
    addData();
    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  // render
  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3 border">
          <div className="card-header">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}
            <h5
              onClick={() => {
                setSaeef("1002");
                setShowHelp(true);
              }}
            >
              מסמכי המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly ? (
            <div className="card-body ">
              <form onSubmit={handleSubmit} className="mbsc-form-group ">
                <Row>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="doc_type" className="required-label">
                        בחר סוג מסמך:{" "}
                      </label>
                      <select
                        name="doc_type"
                        onChange={handleChange}
                        value={newDoc.doc_type}
                        required
                      >
                        <option key="0" value="" defaultValue="0">
                          בחר סוג מסמך
                        </option>
                        {docOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br></br>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="file_url" className="required-label">
                        בחר מסמך:{" "}
                      </label>{" "}
                      <br />
                      <input
                        onClick={() => {
                          setIsUplading(true);
                        }}
                        required
                        type="file"
                        name="file_url"
                        accept="image/jpeg,image/png,image/gif,application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/x-zip-compressed"
                        onChange={(e) => {
                          handleFileChange(e);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                {isUplading ? (
                  <>
                    {" "}
                    <Spinner animation="border" variant="danger" visible />
                    <label>המתן עד סיום הפעולה.</label>
                  </>
                ) : null}
                <br />
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
            </div>
          ) : (
            ""
          )}
        </div>
      </center>
    </div>
  );
}
